import { Avatar } from '@/components/sui/avatar'
import { EMPTY_CELL } from '@/lib/report-labels'

interface PersonCellProps {
  name: string | null | undefined
  avatar?: string | null
  size?: 'sm' | 'md'
}

const SIZES = {
  sm: {
    root: 'flex min-w-0 items-center gap-1',
    avatar: 'size-4 shrink-0',
    fallback: 'text-[7px]',
  },
  md: {
    root: 'flex items-center gap-2',
    avatar: 'size-6 shrink-0',
    fallback: 'text-[10px]',
  },
}

export function PersonCell({
  name,
  avatar = null,
  size = 'md',
}: PersonCellProps) {
  if (!name) return <>{EMPTY_CELL}</>

  const tokens = SIZES[size]

  return (
    <span className={tokens.root}>
      <Avatar
        name={name}
        src={avatar}
        className={tokens.avatar}
        fallbackClassName={tokens.fallback}
      />
      <span className="truncate">{name}</span>
    </span>
  )
}
